'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var caretDownSharp = require('./caret-down-sharp-8232c090.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Title = styled__default.button(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  padding: 0;\n  border: none;\n  width: 100%;\n  display: flex;\n  cursor: pointer;\n"], ["\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  padding: 0;\n  border: none;\n  width: 100%;\n  display: flex;\n  cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.transparent;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var CaretStyled = styled__default(caretDownSharp.CaretDownSharp)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  ", ";\n  margin: auto 8px auto auto;\n"], ["\n  ", ";\n  margin: auto 8px auto auto;\n"])), function (props) { return (props.isOpen ? 'transform: rotate(180deg)' : null); });
var Content = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  overflow-y: hidden;\n  display: ", ";\n"], ["\n  overflow-y: hidden;\n  display: ", ";\n"])), function (props) { return (props.isOpen ? 'block' : 'none'); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.CaretStyled = CaretStyled;
exports.Container = Container;
exports.Content = Content;
exports.Title = Title;
